<template>
  <div
    v-b-tooltip.hover="'Agrega una liga a contenido específico'"
    class="compose-mail-form-field"
  >
    <label
      for="notification-url"
      class="font-weight-bolder"
    >
      URL:
    </label>
    <b-form-input
      id="notification-url"
      v-model="url.l"
      placeholder="Liga a contenido específico (opcional)"
      @input="$emit('add-url', url)"
    />

    <!-- Dropdown de tipo de url -->
    <component
      :is="availableComponentUrlTypeDropdown"
      ref="dropdownPriorityRef"
      @add-url-type="url.t = $event"
    />
  </div>
</template>

<script>
import {
  BFormInput,
  VBTooltip,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import useNotificationComponse from '../useNotificationComponse'

const UrlNotificationTypeDropdown = () => import('./UrlNotificationTypeDropdown.vue')

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormInput,

    // Dynamic Components
    UrlNotificationTypeDropdown,
  },
  setup(_, { emit }) {
    const url = ref({ t: 1 })
    const dropdownPriorityRef = ref(null)
    const { availableComponentUrlTypeDropdown } = useNotificationComponse()

    onMounted(() => emit('add-url', url.value))

    const resetComponent = () => {
      url.value = { t: 1 }
      if (dropdownPriorityRef.value !== null && typeof dropdownPriorityRef.value.resetComponent === 'function') dropdownPriorityRef.value.resetComponent()
    }

    return {
      url, resetComponent, availableComponentUrlTypeDropdown, dropdownPriorityRef,
    }
  },
}
</script>
